module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/bg1.1c2f3dbc.jpg";